export default __webpack_public_path__ + "static/media/download-page.cb375049.svg";